import React, { useMemo, useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import '../../components/kyc/kycStyle.css'
import './DeedsOfficeSearches.css'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { useMutation, useQuery } from 'react-query'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { ActiveReport } from '../../components/kyc/KycPopupComponent'
import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import { usePropertyDetails } from '../../hooks/use-property-details'
import {
  GetTrackingNumbersFromPropertyProps,
  GetTrackingNumbersFromPropertyResponse,
  getTrackingNumbersFromProperty,
} from '../../api/dots/getTrackingNumbersFromProperty'
import { API_ERROR_MESSAGE } from '../../utils/Constants'
import {
  DotsTrackingStatusResponse,
  getLogFromTrackingNumber,
} from '../../api/dots/getLogFromTrackingNumber'
import { HiPrinter } from 'react-icons/hi'
import { RxCross2 } from 'react-icons/rx'
import PropertyDetails from '../../components/ui/PropertyDetails'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { DotsReport } from '../../components/DeedsOfficeSearches/DotsReport'
import { useDotsProperty } from '../../hooks/use-dots-property'
import moment from 'moment'
import { ExportToExcel } from '../../components/DeedsOfficeSearches/ExportToExcel'
import { getUserInfo } from '../../api/dots/getUserInfo'
import { Style } from 'react-bootstrap/lib/utils/StyleConfig'
// const DotsSubheader = () => {
//   return (
//     <span>
//       If you're tired of waiting for Estate Agent's commission or the proceeds
//       from <br /> a registration of a bond/sale, let{' '}
//       <b>General Finance (GenFin) do the waiting</b>.
//     </span>
//   )
// }
type Steps = 'tracking' | 'selecting'
interface BridgeTwoProps {
  setShow: (value: boolean) => void
  setActiveReport: (value: ActiveReport) => void
  setReportTypeId: (value: number) => void
  hfOwner: string
  hfOwnerIDNoArray: string[]
  identityNumber: string
  setIdentityNumber: (value: string) => void
  hfErfNo: string
  hfSuburb: string
  hfAddress: string
  hfMunicipality: string
  date?: Date | null
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
}
const Dots: React.FC<BridgeTwoProps> = ({
  hfSuburb,
  hfErfNo,
  date,
  setShow,
  setActiveReport,
  hfMunicipality,
  hfAddress,
  setIsError,
  setErrorMessage,
}) => {
  const { owners } = usePropertyDetails()

  // const { selectedProperty } = useSelectedProperty()

  const dotsProperty = useDotsProperty()

  const trackingNumberArguments: GetTrackingNumbersFromPropertyProps =
    useMemo(() => {
      const {
        parcelNumber,
        officeCode,
        portionNumber,
        schemeName,
        allotment,
        sectionNumber,
        propertyType,
        registrationDivision,
        address,
      } = dotsProperty
      return {
        erfNo: parcelNumber,
        townshipName: allotment,
        officeCode,
        unitNo: sectionNumber,
        schemeName,
        propertyType,
        portionNumber,
        parcelNumber,
        registrationDivision,
        address,
      }
    }, [dotsProperty])

  const [step, setStep] = useState<Steps>('tracking')
  const [selectedNumber, setSelectedNumber] =
    useState<GetTrackingNumbersFromPropertyResponse | null>(null)

  // const hasOwners = useMemo(() => owners.length > 0, [owners])

  type TrackingItem = {
    status: string
    date: string
  }

  const { data: trackingNumbers, isLoading: isLoadingTrackingNumbers } =
    useQuery(
      'tracking-numbers',
      async () => getTrackingNumbersFromProperty(trackingNumberArguments),
      {
        onError: (err) => {
          setIsError(true)
          setErrorMessage(API_ERROR_MESSAGE)
        },
      },
    )

  const {
    mutate: getLogs,
    data: logs,
    isLoading: isLoadingLogs,
  } = useMutation('logs', getLogFromTrackingNumber, {
    onError: (err) => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
  })
  const {
    mutate: getUser,
    data: userInformation,
    isLoading: isLoadingUser,
  } = useMutation('userInformation', getUserInfo, {
    onError: (err) => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
  })

  const handleOnTrackingClick =
    (item: GetTrackingNumbersFromPropertyResponse) => async () => {
      setSelectedNumber(item)
      setStep('selecting')
      console.log(dotsProperty)
      await getUser()
      await getLogs({
        trackingNo: item.trackingNumber,
        deedsOfficeCode: item.officeCode,
        address: dotsProperty.address,
        reference: item.entityName,
      })
      console.log(userInformation)
      console.log(logs)
    }

  const downloadBlob = async (blob: Blob | null, fileName: string) => {
    if (!blob) {
      return console.log('unable to view blob from pdf source!')
    }
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    document.appendChild(link)
    link.click()
    document.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }

  return (
    <ScreenLayout
      headerText="Dots Query"
      subHeaderText="You are requesting tracking Number(s) for:"
      price={20}
    >
      <Form.Group style={{ paddingTop: '5px' }}>
        <PropertyDetails />
      </Form.Group>

      <Form.Group>
        {step === 'tracking' && (
          <p style={{ paddingTop: '40px' }}>
            <b>Select Tracking Number from the list below:</b> <br />
            <b>Note: </b>You will be charged for each tracking number you select
          </p>
        )}
        {step === 'selecting' && (
          <div className="selection-section-title-container">
            <p className="listDescription">
              Results for Tracking Number "{selectedNumber?.trackingNumber}"
            </p>
            <div className="selection-section-title-buttons">
              {/* <ExportToExcel
                apiData={{
                  selectedProperty: dotsProperty,
                  statuses: !logs ? [] : logs,
                  requestedDate: moment().format('YYYY-MM-DD'),
                }}
                fileName="test.xlsx"
              /> */}
              <PDFDownloadLink
                document={
                  <DotsReport
                    userInfo={userInformation}
                    requestedDate={moment().format('YYYY-MM-DD')}
                    selectedProperty={dotsProperty}
                    statuses={!logs ? [] : logs}
                    reference={selectedNumber?.entityName}
                  />
                }
              >
                {({ blob }) => (
                  <HiPrinter
                    cursor="pointer"
                    size={20}
                    onClick={() => downloadBlob(blob, 'test.pdf')}
                  />
                )}
              </PDFDownloadLink>
              <RxCross2
                size={20}
                cursor="pointer"
                onClick={() => {
                  setStep('tracking')
                  setSelectedNumber(null)
                }}
              />
            </div>
          </div>
        )}
        {step === 'selecting' && (
          <div className="listContainer">
            <table style={{ width: '565px', marginTop: '20px' }}>
              <tr className="rowBorder">
                <td
                  className="labelMargin colBorderSpliter"
                  style={{ backgroundColor: '#efefef', width: '150px' }}
                >
                  <span className="detailLabel">Tracking Status</span>{' '}
                </td>
                <td
                  className="labelMargin"
                  style={{ backgroundColor: '#efefef' }}
                >
                  <span className="detailLabel">Scanned Date</span>
                </td>
              </tr>
            </table>
          </div>
        )}
        {step === 'tracking' && (
          <table style={{ width: '565px', marginTop: '20px' }}>
            <tr className="rowBorder">
              <td
                className="labelMargin colBorderSpliter"
                style={{ backgroundColor: '#efefef', width: '150px' }}
              >
                <span className="detailLabel">Tracking number</span>{' '}
              </td>
              <td
                className="labelMargin"
                style={{ backgroundColor: '#efefef' }}
              >
                <span className="detailLabel">Reference</span>
              </td>
            </tr>
          </table>
        )}
        <div className="container" style={{ width: '500px', margin: '0px' }}>
          {step === 'tracking' && isLoadingTrackingNumbers && <ListSpinner />}
          {step === 'tracking' &&
            trackingNumbers?.map((item: any, idx: number) => (
              <div
                onClick={handleOnTrackingClick(item)}
                className="listItem"
                key={item.trackingNumber + ' ' + idx}
              >
                <span>{item.trackingNumber}</span>
                <span>{item.entityName}</span>
              </div>
            ))}
          {step === 'selecting' && (
            <>
              {(!logs || logs?.length === 0) && !isLoadingLogs && (
                <h3
                  style={{
                    fontSize: '16px',
                    marginLeft: '10px',
                    marginTop: '10px',
                  }}
                >
                  <br />
                  No records found in deeds office
                  <br />
                </h3>
              )}

              {isLoadingLogs && <ListSpinner />}
              {logs?.map((item: DotsTrackingStatusResponse) => (
                <div className="listItem no-click" key={item.scannedDate}>
                  <span>{item.trackingStatus}</span>
                  <span>{item.scannedDate}</span>
                </div>
              ))}
            </>
          )}
        </div>
        <div>
          {step === 'tracking' && (
            <FooterButtons
              setShow={setShow}
              // isDisabled={isSubmitDisabled()}
              isLoading={isLoadingLogs || isLoadingTrackingNumbers}
            />
          )}
          {step === 'selecting' && (
            <span>
              <div style={{ height: '10px' }} />
              {/* <KycButton
                title="Download"
                onClick={() => alert('download')}
                style={{ width: '200px', marginTop: '10px' }}
              >
                Download
              </KycButton> */}
              <NewAndCloseButtons
                handleAction={() => {}}
                showAction={false}
                handleClose={() => setShow(false)}
              />
            </span>
          )}
        </div>
      </Form.Group>
    </ScreenLayout>
  )
}

export default Dots

export const ListSpinner = () => {
  return (
    <div
      style={{
        height: '100px',
        width: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner
        as="span"
        animation="border"
        variant="dark"
        role="status"
        aria-hidden="true"
      />
    </div>
  )
}
